import { extendClass } from './extend-class'
import { DateTime } from 'luxon'
import { SeDateTimeFormatter } from './date-time-formatter'
import {
  SeDateTimeChunk,
  SeDateTimeFormat,
  SeDateTimeOptions,
  SeDateTimeString,
} from './date-time-types'

export abstract class SePointFormatter {

  public luxon: DateTime

  public initPoint(value: SeDateTimeString, options: SeDateTimeOptions): void {
    this.findChunks = this._findChunks
    this.luxon = DateTime.fromISO(value as SeDateTimeString, { zone: options.zone || 'local' })
    this.isValid = this.luxon.isValid
    this.addConditions([
      { [SeDateTimeFormat.NonCurrentYear]: () => this.nonCurrentYear },
    ])
  }

  private _findChunks(format: string): SeDateTimeChunk[] {
    return [{
      format: format,
      luxon: this.luxon
    }]
  }

  public valueOf(): number {
    return this.luxon.valueOf()
  }

}

export interface SePointFormatter extends SeDateTimeFormatter {}
extendClass(SePointFormatter, SeDateTimeFormatter)
